
export const CardWipContabil = (props) => {
    const { TotaisData,ListaData } = props;

  
    return(
        <div className="table-scroll">
        <table className="table table-bordered table-width">
            <thead>
                {
                    TotaisData?.totalHorasFaturadas != null ? (
                        <tr className="custon-tr-total-lanc">
                            <td colSpan={1} className="text-center ">Total</td>
                            <td colSpan={1}  className="text-center ">{TotaisData?.totalHorasFaturadas}</td>
                            {/* <td className="text-right px-1"><strong>Total de horas</strong></td> */}
                            <td colSpan={1}  className="text-center px-1">R$ {TotaisData?.valorTotalAfaturar} </td>
                            <td className="text-center "></td>                           
                        </tr>      

                    ) : null
                }
                <tr className="table-legend-info">
                <th style={{ width: "25%" }} key="Laudo">Laudo</th>
                <th style={{ width: "25%" }} key="Horas">Horas</th>
                <th style={{ width: "25%" }} key="ValorTotal">Valor Total</th>
                <th style={{ width: "25%" }} key="Cliente">Cliente</th>
           
                </tr>
            </thead>
            <tbody>
                {ListaData?.map((atividade, index) => (
                     
                    <tr key={index}>
                      
                        <td className="text-center text-no-wrap">{atividade.sigla}</td>
                        <td className="text-center text-no-wrap">{atividade.totalHorasFaturadas}</td>
                        <td className="text-center text-no-wrap">{atividade.valorTotalFaturado}</td>                      
                        <td className="text-center text-no-wrap">{atividade.cliente}</td>
                    </tr>
                  
                ))}
            </tbody>


        </table>
    </div>
    )
}

